import { Colors } from '@factorialco/deprecated-design-system'
import { BankingValueObjectsCardTypeEnum } from 'generated/resources/graphql'

export const cardLogoColor = (card: { type: BankingValueObjectsCardTypeEnum }): Colors => {
  switch (card.type) {
    case 'physical':
      return 'grey1000'
    case 'virtual':
    case 'single_use':
      return 'grey000White'
    default:
      return card.type satisfies never
  }
}
